"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackGiftingFlowSocialLinkVisited = exports.useTrackContactSelected = exports.useTrackGiftingFlowMessagePreviewClicked = exports.useTrackGiftingFlowLandingPreviewClicked = exports.useTrackGiftingFlowSelectTemplatePassed = exports.useTrackGiftingFlowConfirmationCheckboxPassed = exports.useTrackGiftingFlowRecipientAddressSubmitted = exports.useTrackGiftingFlowFullResearchRequested = exports.useTrackGiftingFlowStepEdited = exports.useTrackGiftingFlowStepPassedEffect = exports.useTrackChosenCampaign = exports.useTrackContactOneOffSubmit = exports.useTrackSendGiftOpenedEffect = exports.useGiftingFlowPayload = exports.GIFTING_TRACK_TABS = exports.GIFTING_TRACK_STEPS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reactRedux = require("react-redux");

var _react = require("react");

var _services = require("@alycecom/services");

var _auth = require("../../Auth/store/auth.selectors");

var _gift = require("../store/gift/gift.selector");

var _constants = require("../constants");

var _useGiftContext2 = require("./useGiftContext");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GIFTING_TRACK_STEPS = {
  SELECT_PRODUCT: 'product',
  SELECT_INVITATION_TYPE: 'invitation type',
  EDIT_MESSAGE: 'message',
  VIDEO_LANDING_PAGE: 'video',
  OPTIONAL_STEPS: 'optional steps',
  SEND_GIFT: 'send'
};
exports.GIFTING_TRACK_STEPS = GIFTING_TRACK_STEPS;
var GIFTING_TRACK_TABS = {
  ABOUT: 'about',
  SEND: 'send'
};
exports.GIFTING_TRACK_TABS = GIFTING_TRACK_TABS;

var useGiftingFlowPayload = function useGiftingFlowPayload() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var adminId = (0, _reactRedux.useSelector)(_auth.getLoginAsAdminId);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      contextUser = _useGiftContext.user;

  var _ref = user || contextUser,
      orgId = _ref.orgId,
      orgName = _ref.orgName;

  return (0, _react.useMemo)(function () {
    return [{
      adminId
    }, {
      groupId: orgId,
      traits: {
        adminId,
        orgId,
        orgName
      }
    }];
  }, [orgId, adminId, orgName]);
};

exports.useGiftingFlowPayload = useGiftingFlowPayload;

var useTrackSendGiftOpenedEffect = function useTrackSendGiftOpenedEffect(user) {
  var _useGiftingFlowPayloa = useGiftingFlowPayload(user),
      _useGiftingFlowPayloa2 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa, 2),
      payload = _useGiftingFlowPayloa2[0],
      options = _useGiftingFlowPayloa2[1];

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var giftStatus = (0, _reactRedux.useSelector)(_gift.getGiftStatusId);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isTracked = _useState2[0],
      setIsTracked = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!isTracked && giftStatus >= _constants.giftStatuses.PRODUCTS_PROPOSED) {
      trackEvent('Sidebar — opened', _objectSpread(_objectSpread({}, payload), {}, {
        tab: 'send',
        giftId
      }), options);
      setIsTracked(true);
    }
  }, [giftId, giftStatus, isTracked, options, payload, trackEvent]);
};

exports.useTrackSendGiftOpenedEffect = useTrackSendGiftOpenedEffect;

var useTrackContactOneOffSubmit = function useTrackContactOneOffSubmit(user) {
  var _useGiftingFlowPayloa3 = useGiftingFlowPayload(user),
      _useGiftingFlowPayloa4 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa3, 2),
      payload = _useGiftingFlowPayloa4[0],
      options = _useGiftingFlowPayloa4[1];

  var _TrackEvent$useTrackE2 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE2.trackEvent;

  return (0, _react.useCallback)(function (researchSetting) {
    trackEvent('Contact — submitted', _objectSpread(_objectSpread({}, payload), {}, {
      method: 'one-off',
      contactsCount: 1,
      researchSetting
    }), options);
  }, [options, payload, trackEvent]);
};

exports.useTrackContactOneOffSubmit = useTrackContactOneOffSubmit;

var useTrackChosenCampaign = function useTrackChosenCampaign(user) {
  var _useGiftingFlowPayloa5 = useGiftingFlowPayload(user),
      _useGiftingFlowPayloa6 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa5, 2),
      payload = _useGiftingFlowPayloa6[0],
      options = _useGiftingFlowPayloa6[1];

  var _TrackEvent$useTrackE3 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE3.trackEvent;

  return (0, _react.useCallback)(function () {
    trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
      giftStatusId: null,
      stepName: 'campaign'
    }), options);
  }, [options, payload, trackEvent]);
};

exports.useTrackChosenCampaign = useTrackChosenCampaign;

var useTrackGiftingFlowStepPassedEffect = function useTrackGiftingFlowStepPassedEffect() {
  var _useGiftingFlowPayloa7 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa8 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa7, 2),
      payload = _useGiftingFlowPayloa8[0],
      options = _useGiftingFlowPayloa8[1];

  var _TrackEvent$useTrackE4 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE4.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var selectProductState = (0, _reactRedux.useSelector)(_gift.getSelectProductState);
  var selectInvitationTypeState = (0, _reactRedux.useSelector)(_gift.getSelectInvitationTypeState);
  var editTemplateMessageState = (0, _reactRedux.useSelector)(_gift.getTemplateDetailsState);
  var requirementsStateWithoutVideo = (0, _reactRedux.useSelector)(_gift.getRequirementsState);
  var videoLandingPageState = (0, _reactRedux.useSelector)(_gift.getVideoLandingPageState);
  var giftStatusId = (0, _reactRedux.useSelector)(_gift.getGiftStatusId);

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      prevStatuses = _useState4[0],
      setPrevStatuses = _useState4[1];

  (0, _react.useEffect)(function () {
    if (selectProductState === _constants.stepState.PASSED && prevStatuses.selectProductState === _constants.stepState.ACTIVE) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.SELECT_PRODUCT,
        giftId
      }), options);
    }
  }, [giftId, options, payload, prevStatuses.selectProductState, selectProductState, trackEvent]);
  (0, _react.useEffect)(function () {
    if (selectInvitationTypeState === _constants.stepState.PASSED && prevStatuses.selectInvitationTypeState === _constants.stepState.ACTIVE) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.SELECT_INVITATION_TYPE,
        giftId
      }), options);
    }
  }, [giftId, options, payload, prevStatuses.selectInvitationTypeState, selectInvitationTypeState, trackEvent]);
  (0, _react.useEffect)(function () {
    if (editTemplateMessageState === _constants.stepState.PASSED && prevStatuses.editTemplateMessageState === _constants.stepState.ACTIVE) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.EDIT_MESSAGE,
        giftId
      }), options);
    }
  }, [options, editTemplateMessageState, trackEvent, giftId, prevStatuses.editTemplateMessageState, payload]);
  (0, _react.useEffect)(function () {
    if (requirementsStateWithoutVideo === _constants.stepState.PASSED && prevStatuses.requirementsStateWithoutVideo === _constants.stepState.ACTIVE) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.OPTIONAL_STEPS,
        giftId
      }), options);
    }
  }, [giftId, options, payload, prevStatuses.requirementsStateWithoutVideo, requirementsStateWithoutVideo, trackEvent]);
  (0, _react.useEffect)(function () {
    if (videoLandingPageState === _constants.stepState.PASSED && prevStatuses.videoLandingPageState === _constants.stepState.ACTIVE) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.VIDEO_LANDING_PAGE,
        giftId
      }), options);
    }
  }, [options, videoLandingPageState, trackEvent, giftId, prevStatuses.videoLandingPageState, payload]);
  (0, _react.useEffect)(function () {
    if (giftStatusId > _constants.giftStatuses.PRODUCTS_PROPOSED && prevStatuses.giftStatusId !== null && prevStatuses.giftStatusId <= _constants.giftStatuses.PRODUCTS_PROPOSED) {
      trackEvent('Step — passed', _objectSpread(_objectSpread({}, payload), {}, {
        stepName: GIFTING_TRACK_STEPS.SEND_GIFT,
        giftId
      }), options);
    }
  }, [options, giftStatusId, trackEvent, giftId, prevStatuses.giftStatusId, payload]);
  (0, _react.useEffect)(function () {
    setPrevStatuses({
      videoLandingPageState,
      requirementsStateWithoutVideo,
      editTemplateMessageState,
      selectInvitationTypeState,
      selectProductState,
      giftStatusId
    });
  }, [editTemplateMessageState, requirementsStateWithoutVideo, selectInvitationTypeState, selectProductState, videoLandingPageState, giftStatusId]);
};

exports.useTrackGiftingFlowStepPassedEffect = useTrackGiftingFlowStepPassedEffect;

var useTrackGiftingFlowStepEdited = function useTrackGiftingFlowStepEdited() {
  var _useGiftingFlowPayloa9 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa10 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa9, 2),
      payload = _useGiftingFlowPayloa10[0],
      options = _useGiftingFlowPayloa10[1];

  var _TrackEvent$useTrackE5 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE5.trackEvent;

  return (0, _react.useCallback)(function (stepName) {
    trackEvent('Step — edited', _objectSpread(_objectSpread({}, payload), {}, {
      stepName
    }), options);
  }, [options, payload, trackEvent]);
};

exports.useTrackGiftingFlowStepEdited = useTrackGiftingFlowStepEdited;

var useTrackGiftingFlowFullResearchRequested = function useTrackGiftingFlowFullResearchRequested() {
  var _useGiftingFlowPayloa11 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa12 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa11, 2),
      payload = _useGiftingFlowPayloa12[0],
      options = _useGiftingFlowPayloa12[1];

  var _TrackEvent$useTrackE6 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE6.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function () {
    trackEvent('Full research — requested', _objectSpread(_objectSpread({}, payload), {}, {
      giftId
    }), options);
  }, [giftId, options, payload, trackEvent]);
};

exports.useTrackGiftingFlowFullResearchRequested = useTrackGiftingFlowFullResearchRequested;

var useTrackGiftingFlowRecipientAddressSubmitted = function useTrackGiftingFlowRecipientAddressSubmitted() {
  var _useGiftingFlowPayloa13 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa14 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa13, 2),
      payload = _useGiftingFlowPayloa14[0],
      options = _useGiftingFlowPayloa14[1];

  var _TrackEvent$useTrackE7 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE7.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function (isOnResearch) {
    trackEvent('Recipient address — submitted', _objectSpread(_objectSpread({}, payload), {}, {
      giftId,
      address: isOnResearch ? 'requested' : 'provided'
    }), options);
  }, [trackEvent, payload, giftId, options]);
};

exports.useTrackGiftingFlowRecipientAddressSubmitted = useTrackGiftingFlowRecipientAddressSubmitted;

var useTrackGiftingFlowConfirmationCheckboxPassed = function useTrackGiftingFlowConfirmationCheckboxPassed() {
  var _useGiftingFlowPayloa15 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa16 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa15, 2),
      payload = _useGiftingFlowPayloa16[0],
      options = _useGiftingFlowPayloa16[1];

  var _TrackEvent$useTrackE8 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE8.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function () {
    trackEvent('Confirmation checkbox — passed', _objectSpread(_objectSpread({}, payload), {}, {
      giftId
    }), options);
  }, [trackEvent, payload, giftId, options]);
};

exports.useTrackGiftingFlowConfirmationCheckboxPassed = useTrackGiftingFlowConfirmationCheckboxPassed;

var useTrackGiftingFlowSelectTemplatePassed = function useTrackGiftingFlowSelectTemplatePassed() {
  var _useGiftingFlowPayloa17 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa18 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa17, 2),
      payload = _useGiftingFlowPayloa18[0],
      options = _useGiftingFlowPayloa18[1];

  var _TrackEvent$useTrackE9 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE9.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function (_ref2) {
    var template = _ref2.templateType;
    trackEvent('Step - passed', _objectSpread(_objectSpread({}, payload), {}, {
      giftId,
      template,
      stepName: 'select template'
    }), options);
  }, [giftId, options, payload, trackEvent]);
};

exports.useTrackGiftingFlowSelectTemplatePassed = useTrackGiftingFlowSelectTemplatePassed;

var useTrackGiftingFlowLandingPreviewClicked = function useTrackGiftingFlowLandingPreviewClicked() {
  var _useGiftingFlowPayloa19 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa20 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa19, 2),
      payload = _useGiftingFlowPayloa20[0],
      options = _useGiftingFlowPayloa20[1];

  var _TrackEvent$useTrackE10 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE10.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function (step) {
    trackEvent('Landing preview — clicked', _objectSpread(_objectSpread({}, payload), {}, {
      giftId,
      step
    }), options);
  }, [trackEvent, payload, giftId, options]);
};

exports.useTrackGiftingFlowLandingPreviewClicked = useTrackGiftingFlowLandingPreviewClicked;

var useTrackGiftingFlowMessagePreviewClicked = function useTrackGiftingFlowMessagePreviewClicked() {
  var _useGiftingFlowPayloa21 = useGiftingFlowPayload(),
      _useGiftingFlowPayloa22 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa21, 2),
      payload = _useGiftingFlowPayloa22[0],
      options = _useGiftingFlowPayloa22[1];

  var _TrackEvent$useTrackE11 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE11.trackEvent;

  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  return (0, _react.useCallback)(function (step) {
    trackEvent('Message preview — clicked', _objectSpread(_objectSpread({}, payload), {}, {
      giftId,
      step
    }), options);
  }, [trackEvent, payload, giftId, options]);
};

exports.useTrackGiftingFlowMessagePreviewClicked = useTrackGiftingFlowMessagePreviewClicked;

var useTrackContactSelected = function useTrackContactSelected(user) {
  var _useGiftingFlowPayloa23 = useGiftingFlowPayload(user),
      _useGiftingFlowPayloa24 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa23, 2),
      payload = _useGiftingFlowPayloa24[0],
      options = _useGiftingFlowPayloa24[1];

  var _TrackEvent$useTrackE12 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE12.trackEvent;

  return (0, _react.useCallback)(function (source) {
    trackEvent('Contact — selected', _objectSpread(_objectSpread({}, payload), {}, {
      source
    }), options);
  }, [options, payload, trackEvent]);
};

exports.useTrackContactSelected = useTrackContactSelected;

var useTrackGiftingFlowSocialLinkVisited = function useTrackGiftingFlowSocialLinkVisited() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useGiftingFlowPayloa25 = useGiftingFlowPayload(user),
      _useGiftingFlowPayloa26 = (0, _slicedToArray2.default)(_useGiftingFlowPayloa25, 2),
      payload = _useGiftingFlowPayloa26[0],
      options = _useGiftingFlowPayloa26[1];

  var _TrackEvent$useTrackE13 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE13.trackEvent;

  return (0, _react.useCallback)(function (tab, link) {
    trackEvent('Social link — visited', _objectSpread(_objectSpread({}, payload), {}, {
      tab,
      link
    }), options);
  }, [trackEvent, payload, options]);
};

exports.useTrackGiftingFlowSocialLinkVisited = useTrackGiftingFlowSocialLinkVisited;